import { render, staticRenderFns } from "./_bulk_tag_messages.vue?vue&type=template&id=97222e4c&scoped=true&"
import script from "./_bulk_tag_messages.vue?vue&type=script&lang=js&"
export * from "./_bulk_tag_messages.vue?vue&type=script&lang=js&"
import style0 from "./_bulk_tag_messages.vue?vue&type=style&index=0&id=97222e4c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97222e4c",
  null
  
)

export default component.exports